// src/services/analytics.js
import api from './api';

export const analyticsService = {
  getOverview: async (facilityId) => {
    try {
      const url = facilityId ? `/analytics/overview?facility=${facilityId}` : '/analytics/overview';
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics overview:', error);
      throw error;
    }
  },

  getTrends: async (days = 30, facilityId) => {
    try {
      let url = `/analytics/trends?days=${days}`;
      if (facilityId) url += `&facility=${facilityId}`;
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics trends:', error);
      throw error;
    }
  },

  getRadiologistPerformance: async (facilityId) => {
    try {
      const url = facilityId ? `/analytics/radiologist-performance?facility=${facilityId}` : '/analytics/radiologist-performance';
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching radiologist performance:', error);
      throw error;
    }
  }
};

export const getStudyStatistics = async () => {
  try {
    const response = await api.get('/studies/stats/overview');
    return response.data;
  } catch (error) {
    console.error('Get statistics error:', error);
    throw error;
  }
};

export const getTATStatistics = async (filters = {}) => {
  try {
    const response = await api.get('/studies/stats/tat', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Get TAT statistics error:', error);
    throw error;
  }
};

export const getRadiologistStatistics = async (radiologistId) => {
  try {
    const response = await api.get(`/studies/stats/radiologist/${radiologistId}`);
    return response.data;
  } catch (error) {
    console.error('Get radiologist statistics error:', error);
    throw error;
  }
};

export const updateStudyStatistics = async (studyId) => {
  try {
    const response = await api.post(`/studies/${studyId}/update-statistics`);
    return response.data;
  } catch (error) {
    console.error('Update statistics error:', error);
    throw error;
  }
};
